export const SMS_SEND_REQUEST = 'SMS_SEND_REQUEST';
export const SMS_SEND_SUCCESS = 'SMS_SEND_SUCCESS';
export const SMS_SEND_FAIL = 'SMS_SEND_FAIL';
export const SMS_SEND_RESET = 'SMS_SEND_RESET';

export const SMS_MULTI_SEND_REQUEST = 'SMS_MULTI_SEND_REQUEST';
export const SMS_MULTI_SEND_SUCCESS = 'SMS_MULTI_SEND_SUCCESS';
export const SMS_MULTI_SEND_FAIL = 'SMS_MULTI_SEND_FAIL';
export const SMS_MULTI_SEND_RESET = 'SMS_MULTI_SEND_RESET';
